<template>
  <div class="container-fluid px-md-4">
    <div class="panel-heading my-2">
      <h2 class="text-left">Client Management</h2>
    </div>
    <form class="needs-validation px-2 pt-2" @submit.prevent="getClients">
      <div
        class="form-group row mx-0 justify-content-end"
        :style="{ marginBottom: '1rem' }"
      >
        <div class="my-2">
          <button
            title="Add new"
            class="k-button k-secondary"
            @click="insert"
            type="button"
          >
            <i class="fa fa-plus mr-2" aria-hidden="true"></i>

            Add new
          </button>
        </div>
      </div>
    </form>
    <div class="example-wrapper" v-if="clients">
      <Grid
        ref="grid"
        :style="{ height: '55vh' }"
        :pageable="true"
        :sortable="true"
        :resizable="true"
        :filterable="true"
        :filter="filter"
        :groupable="false"
        :group="group"
        :sort="sort"
        :skip="skip"
        :data-items="gridData"
        :columns="columns"
        :take="take"
        @datastatechange="dataStateChange"
        @expandchange="expandChange"
      >
        <template v-slot:myTemplate="{ props }">
          <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
        </template>
        <grid-toolbar class="text-left"> </grid-toolbar>
        <grid-norecords> There is no data available custom </grid-norecords>
      </Grid>
      <dialog-container
        v-if="clientInEdit"
        :dialog-title="dialogTitle"
        :data-item="clientInEdit"
        :scopes-list="scopesList"
        :grants-list="grantsList"
        :roles-list="rolesList"
        :errors="errors"
        @save="save"
        @cancel="cancel"
      >
      </dialog-container>
      <error-popup
        v-if="errors.length > 0"
        :errors="errors"
        @cancel="errorPopupOk"
      />
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import DialogContainer from "./DialogContainer";
import { process } from "@progress/kendo-data-query";

import CommandCell from "./CommandCell";
import axios from "axios";
import { oidcSettings } from "../../services/store";
import ErrorPopup from "../../components/ErrorPopup.vue";
export default {
  components: {
    Grid: Grid,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
    "dialog-container": DialogContainer,
    custom: CommandCell,
    errorPopup: ErrorPopup,
  },
  props: {
    identity: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      sort: [{ field: "id", dir: "asc" }],
      clients: undefined,
      selectedIdentity: this.identity,
      base_url: undefined,
      scopesList: [],
      grantsList: [],
      rolesList: [],
      group: [],
      sort: [],
      filter: {
        logic: "and",
        filters: [],
      },
      gridData: [],
      source: [],
      events: [],
      skip: 0,
      take: 10,
      errors: [],
      clientInEdit: undefined,
      columns: [
        {
          field: "clientName",
          title: "Client Name",
        },
        {
          field: "allowedGrantTypes",
          title: "Allowed Grant Types",
          filterable: false,
        },
        {
          field: "allowAccessTokensViaBrowser",
          title: "Allow Access Tokens Via Browser",
          filterable: false,
        },
        {
          field: "redirectUris",
          title: "Redirect URI's",
          filterable: false,
        },
        { cell: "myTemplate", width: "150px", filterable: false },
      ],
    };
  },
  computed: {
    dialogTitle() {
      return `${this.clientInEdit.id === undefined ? "Add" : "Edit"} Client`;
    },
    total() {
      return this.gridData ? this.gridData.length : 0;
    },
  },
  mounted: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    if (this.selectedIdentity != null) {
      this.getScopesList();
      this.getGrantsList();
      this.getClients();
    }
  },
  watch: {
    identity: function () {
      this.selectedIdentity = this.identity;
      this.getClients();
      this.getScopesList();
      this.getGrantsList();
    },
  },
  methods: {
    dataStateChange: function (event) {
      this.createAppState(event.data);
      console.log(event);
    },
    expandChange: function (event) {
      Vue.set(event.dataItem, event.target.$props.expandField, event.value);
    },
    createAppState: function (dataState) {
      this.group = dataState.group;
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.filter = dataState.filter;
      this.sort = dataState.sort;
      console.log(dataState);
      this.getData();
    },
    getData: function () {
      console.log("aaa", this.filter);
      this.gridData = process(this.clients, {
        take: this.take,
        skip: this.skip,
        group: this.group,
        sort: this.sort,
        filter: this.filter,
      });
    },
    errorPopupOk() {
      this.errors = [];
    },
    showSnackbar: function (message) {
      var x = document.getElementById("snackbar");
      x.className = "show";
      if (typeof message === "string" || message instanceof String)
        x.innerHTML = message;
      else x.innerHTML = "Request Failed";
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000);
    },

    async getScopesList() {
      try {
        const response = await axios.get(
          this.base_url + "Client/GetClientScopes",
          {}
        );
        this.scopesList = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    async getGrantsList() {
      try {
        const response = await axios.get(
          this.base_url + "Client/GetClientGrantTypes",
          {}
        );
        this.grantsList = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    async getRolesList() {
      try {
        const response = await axios.get(
          this.base_url + "Role/GetRoles/" + this.selectedIdentity.id
        );
        this.rolesList = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    async getIdentityPools() {
      try {
        const response = await axios.get(
          this.base_url + "IdentityPool/GetIdentityPools"
        );
        this.source = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    async getClients() {
      this.getRolesList();
      try {
        const client_id = oidcSettings.client_id;
        const response = await axios.get(
          this.base_url + "Client/GetClients/" + this.selectedIdentity.id
        );
        this.clients = response.data.result;
        this.getData();
      } catch (err) {
        console.log(err);
      }
    },
    edit(dataItem) {
      this.clientInEdit = this.cloneProduct(dataItem);
    },
    async remove(dataItem) {
      if (dataItem.clientId == "sample.client.2") {
        this.showSnackbar("Default Client Can Not Be Deleted");
        return;
      } else
        try {
          const response = await axios.delete(
            this.base_url + "Client/DeleteClient/" + dataItem.clientId
          );
          console.log(response.data.message);
          this.clients = this.clients.filter((p) => p.id !== dataItem.id);
          this.getData();
        } catch (err) {
          console.log(err);
        }
    },
    async addClient(dataItem) {
      const client_id = oidcSettings.client_id;
      dataItem.clientSecrets = this.toArray(dataItem.clientSecrets);
      dataItem.allowedCorsOrigins = this.toArray(dataItem.allowedCorsOrigins);
      dataItem.redirectUris = this.toArray(dataItem.redirectUris);
      dataItem.postLogoutRedirectUris = this.toArray(
        dataItem.postLogoutRedirectUris
      );
      let data = {
        ClientID: dataItem.clientId,
        ClientName: dataItem.clientName,
        ClientSecrets: dataItem.clientSecrets,
        AllowedGrantTypes: dataItem.allowedGrantTypes,
        AllowAccessTokensViaBrowser: dataItem.allowAccessTokensViaBrowser,
        AllowOfflineAccess: dataItem.allowOfflineAccess,
        AlwaysIncludeUserClaimsInIdToken:
          dataItem.alwaysIncludeUserClaimsInIdToken,
        AlwaysSendClientClaims: dataItem.alwaysSendClientClaims,
        RequireConsent: dataItem.requireConsent,
        RedirectUris: dataItem.redirectUris,
        RequireClientSecret: dataItem.requireClientSecret,
        AllowedCorsOrigins: dataItem.allowedCorsOrigins,
        PostLogoutRedirectUris: dataItem.postLogoutRedirectUris,
        AllowedScopes: dataItem.allowedScopes,
        AccessTokenLifetime: parseInt(dataItem.accessTokenLifetime, 10) || 0,
        RefreshTokenLifetime: parseInt(dataItem.refreshTokenLifetime, 10) || 0,
        IsCustomAuthentication: dataItem.isCustomAuthentication,
        SendMailOnUserActivation: dataItem.sendMailOnUserActivation,
        IsDefaultOTP: dataItem.isDefaultOTP,
        IsTenantBased: dataItem.isTenantBased,
        AllowedRoles: dataItem.allowedRoles,
        PrivilegedRoles: dataItem.privilegedRoles|| [],
        DefaultRoles: dataItem.defaultRoles || [],
        IsExternalRegAllowed: dataItem.isExternalRegAllowed,
      };
      try {
        const response = await axios
          .post(
            this.base_url + "Client/AddClient/" + this.selectedIdentity.id,
            data
          )
          .then((response) => {
            var newObject = response.data.result;
            this.clients.push(newObject);
            this.dataItem = {};
            this.clientInEdit = undefined;
            this.getClients();
          })
          .catch((err) => {
            this.errors.push(err.response.data.message);
          });
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    toArray: function (val) {
      if (Array.isArray(val) || val == undefined) return val;
      else return val.split(",");
    },
    async editClient(dataItem) {
      dataItem.clientSecrets = this.toArray(dataItem.clientSecrets);
      dataItem.allowedCorsOrigins = this.toArray(dataItem.allowedCorsOrigins);
      dataItem.redirectUris = this.toArray(dataItem.redirectUris);
      dataItem.postLogoutRedirectUris = this.toArray(
        dataItem.postLogoutRedirectUris
      );

      let data = {
        ClientID: dataItem.clientId,
        id: dataItem.id,
        ClientName: dataItem.clientName,
        //ClientSecrets: dataItem.clientSecrets,
        AllowedGrantTypes: dataItem.allowedGrantTypes,
        AllowAccessTokensViaBrowser: dataItem.allowAccessTokensViaBrowser,
        AlwaysIncludeUserClaimsInIdToken:
          dataItem.alwaysIncludeUserClaimsInIdToken,
        AllowOfflineAccess: dataItem.allowOfflineAccess,
        AlwaysSendClientClaims: dataItem.alwaysSendClientClaims,
        RequireConsent: dataItem.requireConsent,
        RedirectUris: dataItem.redirectUris,
        RequireClientSecret: dataItem.requireClientSecret,
        AllowedCorsOrigins: dataItem.allowedCorsOrigins,
        PostLogoutRedirectUris: dataItem.postLogoutRedirectUris,
        AllowedScopes: dataItem.allowedScopes,
        AccessTokenLifetime: parseInt(dataItem.accessTokenLifetime, 10) || 0,
        RefreshTokenLifetime: parseInt(dataItem.refreshTokenLifetime, 10) || 0,
        //IdentityPoolID: this.selectedIdentity.id,
        SendMailOnUserActivation: dataItem.sendMailOnUserActivation,
        IsCustomAuthentication: dataItem.isCustomAuthentication,
        IsDefaultOTP: dataItem.isDefaultOTP,
        IsTenantBased: dataItem.isTenantBased,
        AllowedRoles: dataItem.allowedRoles,
        PrivilegedRoles: dataItem.privilegedRoles || [],
        DefaultRoles: dataItem.defaultRoles || [],
        IsExternalRegAllowed: dataItem.isExternalRegAllowed,
      };
      try {
        const response = await axios.put(
          this.base_url + "Client/UpdateClient/" + this.selectedIdentity.id,
          data
        );
        const index = this.clients.findIndex((p) => p.id === dataItem.id);
        this.clients.splice(index, 1, dataItem);
        this.dataItem = {};
        this.clientInEdit = undefined;
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    save() {
      const dataItem = this.clientInEdit;
      const clients = this.clients.slice();
      const isNewClient = this.clientInEdit.id == undefined;
      if (isNewClient) {
        this.addClient(dataItem);
      } else {
        this.editClient(dataItem);
      }
      //this.clientInEdit = undefined;
    },
    cancel() {
      this.clientInEdit = undefined;
    },
    insert() {
      this.clientInEdit = {};
    },
    cloneProduct(product) {
      return Object.assign({}, product);
    },
  },
};
</script>
<style >
.error {
  color: brown;
  margin: auto;
  text-align: left;
  padding: 5px;
}
.needs-validation {
  background: white;
}
.k-widget.k-window.k-dialog {
  overflow: auto;
}
.k-prompt-container,
.k-window-content {
  max-height: 400px;
}
</style>